import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSend = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 18,
	viewBox: "0 0 19 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.426 8.095L1.42601 0.0949962C1.25484 0.0140123 1.06418 -0.0166567 0.876254 0.00656362C0.688325 0.029784 0.510866 0.105937 0.364559 0.226148C0.218252 0.346359 0.109123 0.505676 0.0498908 0.685531C-0.00934141 0.865386 -0.0162373 1.05837 0.030007 1.242L1.96901 9L0.030007 16.758C-0.01667 16.9417 -0.0100757 17.1349 0.0490187 17.315C0.108113 17.495 0.217264 17.6546 0.363704 17.7749C0.510143 17.8952 0.687816 17.9713 0.87594 17.9944C1.06406 18.0174 1.25486 17.9864 1.42601 17.905L18.426 9.905C18.5978 9.82424 18.7431 9.69625 18.8448 9.53599C18.9466 9.37574 19.0006 9.18983 19.0006 9C19.0006 8.81017 18.9466 8.62426 18.8448 8.464C18.7431 8.30374 18.5978 8.17575 18.426 8.095ZM2.48101 15.197L3.32001 11.84L9.00001 9L3.32001 6.16L2.48101 2.803L15.651 9L2.48101 15.197Z",
		fill: "currentColor"
	})
});
export default SvgSend;
